(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8384],{

/***/ 50778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ProductList; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/lodash/orderBy.js
var orderBy = __webpack_require__(75472);
var orderBy_default = /*#__PURE__*/__webpack_require__.n(orderBy);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/objectManipulation.js
var objectManipulation = __webpack_require__(18745);
// EXTERNAL MODULE: ./src/utils/products.js
var utils_products = __webpack_require__(1003);
// EXTERNAL MODULE: ./node_modules/react-icons/go/index.esm.js
var index_esm = __webpack_require__(66653);
// EXTERNAL MODULE: ./src/store/loader.js
var loader = __webpack_require__(58766);
// EXTERNAL MODULE: ./src/components/NoProductsPlaceholder.module.scss
var NoProductsPlaceholder_module = __webpack_require__(2719);
var NoProductsPlaceholder_module_default = /*#__PURE__*/__webpack_require__.n(NoProductsPlaceholder_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/NoProductsPlaceholder.jsx






function NoProductsPlaceholder() {
  var _useState = (0,react.useState)(),
      loaderIsVisible = _useState[0],
      setLoaderIsVisible = _useState[1];

  (0,react.useEffect)(function () {
    var loader$ = loader/* default.subscribe */.Z.subscribe(function (_ref) {
      var isVisible = _ref.isVisible;
      setLoaderIsVisible(isVisible);
    });
    return function () {
      loader$.unsubscribe();
    };
  }, []);
  if (loaderIsVisible) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (NoProductsPlaceholder_module_default()).noProductsContainer,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* GoSearch */.a4h, {
      className: (NoProductsPlaceholder_module_default()).icon
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: (NoProductsPlaceholder_module_default()).noProducts,
      children: "\u0394\u03B5\u03BD \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03BD \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03B1 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03B1 \u03B3\u03B9\u03B1 \u03AC\u03BC\u03B5\u03C3\u03B7 \u03C0\u03B1\u03C1\u03AC\u03B4\u03BF\u03C3\u03B7 \u03C3\u03B5 \u03B1\u03C5\u03C4\u03AE \u03C4\u03B7\u03BD \u03BA\u03B1\u03C4\u03B7\u03B3\u03BF\u03C1\u03AF\u03B1."
    })]
  });
}
// EXTERNAL MODULE: ./node_modules/lodash/last.js
var last = __webpack_require__(10928);
var last_default = /*#__PURE__*/__webpack_require__.n(last);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/utils/analytics.js
var analytics = __webpack_require__(99700);
// EXTERNAL MODULE: ./src/components/ProductsMenu/ProductMenu.module.scss
var ProductMenu_module = __webpack_require__(54820);
var ProductMenu_module_default = /*#__PURE__*/__webpack_require__.n(ProductMenu_module);
;// CONCATENATED MODULE: ./src/components/ProductsMenu/ProductListBanner.jsx







var GA_BANNER_CREATIVE_TAG = 'productsMenu_banner';
function ProductListBanner(_ref) {
  var slug = _ref.slug,
      banners = _ref.banners,
      categories = _ref.categories,
      category = _ref.category,
      isSecondLevelPage = _ref.isSecondLevelPage;

  var _useState = (0,react.useState)(),
      bannerShown = _useState[0],
      setBannerShown = _useState[1];

  var router = (0,next_router.useRouter)();

  function onInView() {
    var promo = (0,analytics/* objectToPromoEventTransformer */.ED)(bannerShown === null || bannerShown === void 0 ? void 0 : bannerShown.name, bannerShown === null || bannerShown === void 0 ? void 0 : bannerShown.image, GA_BANNER_CREATIVE_TAG);
    (0,analytics/* viewPromotion */.vk)(promo);
  }

  function onClick() {
    var promo = (0,analytics/* objectToPromoEventTransformer */.ED)(bannerShown === null || bannerShown === void 0 ? void 0 : bannerShown.name, bannerShown === null || bannerShown === void 0 ? void 0 : bannerShown.image, GA_BANNER_CREATIVE_TAG);
    var redirectUrl = bannerShown === null || bannerShown === void 0 ? void 0 : bannerShown.link;
    (0,analytics/* selectPromotion */.G5)(promo);
    if (!redirectUrl) return;
    var url = new URL(redirectUrl);
    var urlFullPath = last_default()(url.toString().split(url.hostname));
    router.push(urlFullPath);
  }

  function getBannerCategory() {
    if (!banners.length) return;

    if (isSecondLevelPage) {
      var childCategoryBanner = banners.find(function (b) {
        return b.page === category.slug;
      });
      return childCategoryBanner;
    }

    var parentCategory = categories.find(function (_category) {
      return _category.slugAscii === slug[0];
    });
    var parentCategoryBanner = banners.find(function (b) {
      return b.page === parentCategory.slug;
    });
    return parentCategoryBanner;
  }

  (0,react.useEffect)(function () {
    var bannerToShow = getBannerCategory();
    setBannerShown(bannerToShow);
  }, [slug]);
  (0,react.useEffect)(function () {
    if (!bannerShown) return;
    onInView();
  }, [bannerShown]);

  if (slug[0] !== 'offers' && bannerShown && bannerShown.image !== '' && bannerShown.image !== undefined) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: bannerShown.link || '#',
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        className: (ProductMenu_module_default()).bannerLink,
        onClick: onClick,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          className: (ProductMenu_module_default()).bannerImage,
          src: bannerShown.image,
          alt: bannerShown.alt
        })
      })
    });
  }

  return null;
}
// EXTERNAL MODULE: ./src/components/ProductsMenu/ProductListItem.jsx + 1 modules
var ProductListItem = __webpack_require__(57730);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/ProductsMenu/ThirdLevelCategories.module.scss
var ThirdLevelCategories_module = __webpack_require__(66351);
var ThirdLevelCategories_module_default = /*#__PURE__*/__webpack_require__.n(ThirdLevelCategories_module);
;// CONCATENATED MODULE: ./src/components/ProductsMenu/ThirdLevelCategories.jsx





function ThirdLevelCategories(_ref) {
  var _cn;

  var categories = _ref.categories,
      selectedCategoryId = _ref.selectedCategoryId,
      _onClick = _ref.onClick;
  if (!categories.length) return null;
  var categoriesText = {
    el: {
      all: 'Όλα'
    }
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (ThirdLevelCategories_module_default()).container,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
      className: classnames_default()((_cn = {}, (0,defineProperty/* default */.Z)(_cn, (ThirdLevelCategories_module_default()).button, selectedCategoryId !== '0'), (0,defineProperty/* default */.Z)(_cn, (ThirdLevelCategories_module_default()).buttonSelected, selectedCategoryId === '0'), _cn)),
      type: "button",
      onClick: function onClick() {
        return _onClick('0', true);
      },
      children: categoriesText.el.all
    }), categories.map(function (c) {
      var _cn2;

      if (!c.numberOfProductsToDisplay) return null;
      return /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        className: classnames_default()((_cn2 = {}, (0,defineProperty/* default */.Z)(_cn2, (ThirdLevelCategories_module_default()).button, c._id !== selectedCategoryId), (0,defineProperty/* default */.Z)(_cn2, (ThirdLevelCategories_module_default()).buttonSelected, c._id === selectedCategoryId), _cn2)),
        type: "button",
        onClick: function onClick() {
          return _onClick(c._id, false);
        },
        children: c.name
      }, c._id);
    })]
  });
}
;// CONCATENATED MODULE: ./src/components/ProductsMenu/ProductList.jsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














var ALL_BRANDS_VALUE = '';
function ProductList(_ref) {
  var _products$, _products$$category, _products$$category$c, _products$2, _products$2$category;

  var _ref$products = _ref.products,
      products = _ref$products === void 0 ? [] : _ref$products,
      _ref$category = _ref.category,
      category = _ref$category === void 0 ? {} : _ref$category,
      slug = _ref.slug,
      _ref$banners = _ref.banners,
      banners = _ref$banners === void 0 ? [] : _ref$banners,
      categories = _ref.categories,
      showBySelection = _ref.showBySelection,
      isSecondLevelPage = _ref.isSecondLevelPage,
      loading = _ref.loading,
      _ref$categoriesShowin = _ref.categoriesShowing,
      categoriesShowing = _ref$categoriesShowin === void 0 ? [] : _ref$categoriesShowin,
      itemListId = _ref.itemListId,
      itemListName = _ref.itemListName;

  var _useState = (0,react.useState)(''),
      productsShown = _useState[0],
      setProductsShown = _useState[1];

  var _useState2 = (0,react.useState)(ALL_BRANDS_VALUE),
      selectedBrand = _useState2[0],
      setSelectedBrand = _useState2[1];

  var _useState3 = (0,react.useState)([]),
      brandProducts = _useState3[0],
      setBrandProducts = _useState3[1];

  var _useState4 = (0,react.useState)('0'),
      selectedThirdLevelCategoryId = _useState4[0],
      setSelectedThirdLevelCategoryId = _useState4[1];

  var _useState5 = (0,react.useState)({}),
      brandToProductIdsMap = _useState5[0],
      setBrandToProductIdsMap = _useState5[1];

  var router = (0,next_router.useRouter)();
  var productsParentCategory = ((_products$ = products[0]) === null || _products$ === void 0 ? void 0 : (_products$$category = _products$.category) === null || _products$$category === void 0 ? void 0 : (_products$$category$c = _products$$category.categoryTree) === null || _products$$category$c === void 0 ? void 0 : _products$$category$c.parent) || ((_products$2 = products[0]) === null || _products$2 === void 0 ? void 0 : (_products$2$category = _products$2.category) === null || _products$2$category === void 0 ? void 0 : _products$2$category._id);
  var offerTitleObject = categoriesShowing.find(function (_category) {
    return _category._id === productsParentCategory;
  });
  var offerTitle = offerTitleObject === null || offerTitleObject === void 0 ? void 0 : offerTitleObject.name;

  function getThirdLevelFromSlugAscii(parentCategory, slugAscii) {
    return parentCategory.subCategories.find(function (thirdLevel) {
      return thirdLevel.slugAscii === slugAscii;
    });
  }

  function addParamsOnURL() {
    var filterId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : selectedThirdLevelCategoryId;
    var brand = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : selectedBrand;

    if (filterId === '0') {
      var _query = _objectSpread({}, (0,objectManipulation/* getValidObject */.t9)('brand', brand));

      router.push({
        pathname: "/categories/".concat(slug.join('/')),
        query: _query
      }, undefined, {
        shallow: true
      });
      setSelectedThirdLevelCategoryId('0');
      return;
    }

    var filter = category.subCategories.find(function (thirdLevelCategory) {
      return thirdLevelCategory._id === filterId;
    });

    var query = _objectSpread(_objectSpread({}, (0,objectManipulation/* getValidObject */.t9)('filter', filter === null || filter === void 0 ? void 0 : filter.slugAscii)), (0,objectManipulation/* getValidObject */.t9)('brand', brand));

    router.push({
      pathname: "/categories/".concat(slug.join('/')),
      query: query
    }, undefined, {
      shallow: true
    });
  }

  var _useState6 = (0,react.useState)([]),
      thirdLvlCategoriesSorted = _useState6[0],
      setThirdLevelCategoriesSorted = _useState6[1];

  function displayThirdLevel(categorySelected) {
    var subCategories = categorySelected.subCategories;
    return subCategories.some(function (c) {
      return c.numberOfProductsToDisplay !== 0;
    });
  }

  function onSelectBrand(_ref2) {
    var value = _ref2.target.value;
    setSelectedBrand(value);
    addParamsOnURL(selectedThirdLevelCategoryId, value);
  }

  function onClickThirdLevelCategory(categoryId, showEverything) {
    if (categoryId === selectedThirdLevelCategoryId) {
      return;
    }

    if (showEverything) {
      setSelectedBrand(ALL_BRANDS_VALUE);
      addParamsOnURL('0', null);
      setSelectedThirdLevelCategoryId('0');
      return;
    }

    setSelectedBrand(ALL_BRANDS_VALUE);
    addParamsOnURL(categoryId, null);
    setSelectedThirdLevelCategoryId(categoryId);
  }

  function getProductsByCategory() {
    if (selectedThirdLevelCategoryId === '0') {
      var _productsByCategory = products;
      return _productsByCategory;
    }

    var productsByCategory = !selectedThirdLevelCategoryId ? products : products.filter(function (p) {
      return p.category._id === selectedThirdLevelCategoryId;
    });
    return productsByCategory;
  }

  function getProductsByBrand(productsByCategory) {
    var productsByBrand = selectedBrand === ALL_BRANDS_VALUE ? productsByCategory : productsByCategory.filter(function (_ref3) {
      var _id = _ref3._id;
      return brandToProductIdsMap[selectedBrand].includes(_id);
    });
    return productsByBrand;
  }

  function setFilterFromURLParams(brandToProductIdMap) {
    var _router$query, _router$query2, _router$query4;

    if (router !== null && router !== void 0 && (_router$query = router.query) !== null && _router$query !== void 0 && _router$query.filter) {
      var selectedThirdLevel = getThirdLevelFromSlugAscii(category, router.query.filter);
      setSelectedThirdLevelCategoryId(selectedThirdLevel._id);
    }

    if (router !== null && router !== void 0 && (_router$query2 = router.query) !== null && _router$query2 !== void 0 && _router$query2.brand && brandToProductIdMap[router.query.brand]) {
      var _router$query3;

      setSelectedBrand(router === null || router === void 0 ? void 0 : (_router$query3 = router.query) === null || _router$query3 === void 0 ? void 0 : _router$query3.brand);
    } else if (!(router !== null && router !== void 0 && (_router$query4 = router.query) !== null && _router$query4 !== void 0 && _router$query4.brand)) {
      setSelectedBrand('');
    }
  }

  function getFilteredProducts() {
    setProductsShown([]);
    var productsByCategory = getProductsByCategory();
    setBrandProducts(productsByCategory);
    var productsByBrand = getProductsByBrand(productsByCategory);
    var productsByBannerOptions = (0,utils_products/* getSortedProducts */.LB)(productsByBrand, showBySelection);
    setProductsShown(productsByBannerOptions);
  }

  (0,react.useEffect)(function () {
    if (selectedThirdLevelCategoryId) setSelectedThirdLevelCategoryId('0');
  }, [slug]);
  (0,react.useEffect)(function () {
    if (!displayThirdLevel(category)) return;
    var thirdLevelCategories = category.subCategories;
    var sortedCategories = orderBy_default()(thirdLevelCategories, ['categoryIndex', 'divisionCode'], 'asc');
    setThirdLevelCategoriesSorted(sortedCategories);
  }, []);
  (0,react.useEffect)(function () {
    getFilteredProducts();
  }, [selectedBrand, selectedThirdLevelCategoryId, showBySelection, products]);
  (0,react.useEffect)(function () {
    if (slug.length === 2) {
      var brandToProductIdMap = (0,utils_products/* getBrandToProductIdMap */.yH)(brandProducts);
      setBrandToProductIdsMap(brandToProductIdMap);
      setFilterFromURLParams(brandToProductIdMap);
    }
  }, [brandProducts]);
  if (!isSecondLevelPage && productsShown.length === 0) return null;
  var brandNames = Object.keys(brandToProductIdsMap).sort();
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (ProductMenu_module_default()).categoryContainer,
    children: (productsShown.length !== 0 && slug[0] === 'offers' || slug[0] !== 'offers') && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      "data-cy": "list-of-products",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (ProductMenu_module_default()).listHeader,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
          className: (ProductMenu_module_default()).listTitle,
          children: slug[0] === 'offers' ? offerTitle : category.name
        }), slug.length === 2 && brandNames && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (ProductMenu_module_default()).options,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (ProductMenu_module_default()).hideOnSmallScreen,
            children: "\u039C\u03AC\u03C1\u03BA\u03B1: "
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("select", {
            className: (ProductMenu_module_default()).selectBrand,
            onChange: onSelectBrand,
            value: selectedBrand,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("option", {
              value: ALL_BRANDS_VALUE,
              children: "\u038C\u03BB\u03B1"
            }), brandNames.map(function (b) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                value: b,
                children: b
              }, b);
            })]
          })]
        })]
      }), slug.length === 2 && displayThirdLevel(category) && /*#__PURE__*/(0,jsx_runtime.jsx)(ThirdLevelCategories, {
        categories: thirdLvlCategoriesSorted,
        selectedCategoryId: selectedThirdLevelCategoryId,
        onClick: onClickThirdLevelCategory
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (ProductMenu_module_default()).bannerContainer,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ProductListBanner, {
          slug: slug,
          banners: banners,
          categories: categories,
          category: category,
          isSecondLevelPage: isSecondLevelPage
        }), productsShown.length !== 0 && !loading && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: productsShown.map(function (p, i) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(ProductListItem/* default */.Z, {
              _product: p,
              positionInList: i + 1,
              itemListId: itemListId,
              itemListName: itemListName
            }, p._id);
          })
        }), productsShown.length === 0 && !loading && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (ProductMenu_module_default()).centerNoProducts,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(NoProductsPlaceholder, {})
        })]
      })]
    })
  });
}

/***/ }),

/***/ 58847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Super; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/pages/index.module.scss
var index_module = __webpack_require__(28833);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/components/CategoriesAside/CategoriesAside.jsx + 2 modules
var CategoriesAside = __webpack_require__(6551);
// EXTERNAL MODULE: ./src/components/CategoriesBanner/CategoriesBanner.jsx + 1 modules
var CategoriesBanner = __webpack_require__(11848);
// EXTERNAL MODULE: ./src/components/CategoriesSelect/CategoriesSelect.jsx
var CategoriesSelect = __webpack_require__(16723);
// EXTERNAL MODULE: ./src/components/CustomMetaHead.jsx
var CustomMetaHead = __webpack_require__(92536);
// EXTERNAL MODULE: ./src/components/DeliveryBanner/DeliveryBanner.jsx + 3 modules
var DeliveryBanner = __webpack_require__(54196);
// EXTERNAL MODULE: ./src/components/FavoritesAside/FavoritesAside.jsx
var FavoritesAside = __webpack_require__(79255);
// EXTERNAL MODULE: ./src/components/Footer/Footer.jsx + 5 modules
var Footer = __webpack_require__(31875);
// EXTERNAL MODULE: ./src/components/Header/Header.jsx + 8 modules
var Header = __webpack_require__(3266);
// EXTERNAL MODULE: ./src/components/Navigation/Navigation.jsx
var Navigation = __webpack_require__(86894);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/react-infinite-scroller/index.js
var react_infinite_scroller = __webpack_require__(246);
var react_infinite_scroller_default = /*#__PURE__*/__webpack_require__.n(react_infinite_scroller);
// EXTERNAL MODULE: ./src/store/deliveryMode.js
var store_deliveryMode = __webpack_require__(34525);
// EXTERNAL MODULE: ./src/store/loader.js
var loader = __webpack_require__(58766);
// EXTERNAL MODULE: ./src/store/products.js
var products = __webpack_require__(58345);
// EXTERNAL MODULE: ./src/store/productsCollection.js
var productsCollection = __webpack_require__(67713);
// EXTERNAL MODULE: ./src/utils/index.js
var utils = __webpack_require__(90952);
// EXTERNAL MODULE: ./src/utils/analytics.js
var analytics = __webpack_require__(99700);
// EXTERNAL MODULE: ./src/components/ProductsMenu/ProductList.jsx + 3 modules
var ProductList = __webpack_require__(50778);
// EXTERNAL MODULE: ./src/components/ProductsMenu/ProductListItem.jsx + 1 modules
var ProductListItem = __webpack_require__(57730);
// EXTERNAL MODULE: ./src/components/ProductsMenu/ProductMenu.module.scss
var ProductMenu_module = __webpack_require__(54820);
var ProductMenu_module_default = /*#__PURE__*/__webpack_require__.n(ProductMenu_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/ProductsMenu/SmartProductMenu.jsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
















function SmartProductMenu(_ref) {
  var slug = _ref.slug,
      categories = _ref.categories,
      category = _ref.category,
      subCategory = _ref.subCategory,
      productCollections = _ref.productCollections,
      banners = _ref.banners,
      isSticky = _ref.isSticky,
      showBySelection = _ref.showBySelection,
      isSecondLevelPage = _ref.isSecondLevelPage,
      _ref$staticProducts = _ref.staticProducts,
      staticProducts = _ref$staticProducts === void 0 ? {} : _ref$staticProducts;

  var _useState = (0,react.useState)({}),
      productsShowing = _useState[0],
      setProductsShowing = _useState[1];

  var _useState2 = (0,react.useState)([]),
      categoriesShowing = _useState2[0],
      setCategoriesShowing = _useState2[1];

  var _useState3 = (0,react.useState)(true),
      hasMore = _useState3[0],
      setHasMore = _useState3[1];

  var _useState4 = (0,react.useState)(1),
      infiniteScrollIndex = _useState4[0],
      setInfiniteScrollIndex = _useState4[1];

  var _useState5 = (0,react.useState)(),
      allProductsInCollections = _useState5[0],
      setAllProductsInCollections = _useState5[1];

  var _useState6 = (0,react.useState)(true),
      loading = _useState6[0],
      setLoading = _useState6[1];

  function findProductsSubcategory(subcategory, _products, isOffers) {
    var isSuper = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    if (!_products || (_products === null || _products === void 0 ? void 0 : _products.length) === 0) {
      return 0;
    }

    var allProductsToShow = [];

    if (subcategory.subCategories.length !== 0) {
      var _productsInCategory = _products.filter(function (p) {
        var _p$category, _p$category$categoryT;

        return subcategory._id === (p === null || p === void 0 ? void 0 : (_p$category = p.category) === null || _p$category === void 0 ? void 0 : (_p$category$categoryT = _p$category.categoryTree) === null || _p$category$categoryT === void 0 ? void 0 : _p$category$categoryT.parent);
      });

      var _productsToShow = isOffers ? _productsInCategory.filter(function (p) {
        return p.offerType !== 'none' && p.offerType !== 'super';
      }) : isSuper ? _productsInCategory.filter(function (p) {
        return p.offerType === 'super';
      }) : _productsInCategory;

      allProductsToShow = [].concat((0,toConsumableArray/* default */.Z)(allProductsToShow), (0,toConsumableArray/* default */.Z)(_productsToShow));
      setProductsShowing(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, (0,defineProperty/* default */.Z)({}, subcategory._id, prevState[subcategory._id] ? [].concat((0,toConsumableArray/* default */.Z)(prevState[subcategory._id]), (0,toConsumableArray/* default */.Z)(_productsToShow)) : _productsToShow));
      });
    }

    var productsInCategory = _products.filter(function (p) {
      var _p$category2;

      return subcategory._id === (p === null || p === void 0 ? void 0 : (_p$category2 = p.category) === null || _p$category2 === void 0 ? void 0 : _p$category2._id);
    });

    var productsToShow = isOffers ? productsInCategory.filter(function (p) {
      return p.offerType !== 'none' && p.offerType !== 'super';
    }) : isSuper ? productsInCategory.filter(function (p) {
      return p.offerType === 'super';
    }) : productsInCategory;
    allProductsToShow = [].concat((0,toConsumableArray/* default */.Z)(allProductsToShow), (0,toConsumableArray/* default */.Z)(productsToShow));
    setProductsShowing(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, (0,defineProperty/* default */.Z)({}, subcategory._id, prevState[subcategory._id] ? [].concat((0,toConsumableArray/* default */.Z)(prevState[subcategory._id]), (0,toConsumableArray/* default */.Z)(productsToShow)) : productsToShow));
    });
    return allProductsToShow.length;
  }

  function getProductsToShow(currentCategory, products) {
    var isOffers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSuper = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (!currentCategory) return;
    var count = findProductsSubcategory(currentCategory, products, isOffers, isSuper);
    setLoading(false);
    return count > 0;
  }

  function loadFunc() {
    if (!categories || !categories.length) return;

    if (categoriesShowing.length && !categoriesShowing[infiniteScrollIndex]) {
      setHasMore(false);
      return;
    }

    if (hasMore && categoriesShowing.length) {
      var _category = categoriesShowing[infiniteScrollIndex];
      var isSuper = slug[0] === 'smart';
      getProductsToShow(_category, allProductsInCollections, false, isSuper);
      setInfiniteScrollIndex(infiniteScrollIndex + 1);
      products/* CalledSuperProductCategories.update */.r1.update(infiniteScrollIndex + 1);
    }
  }

  function initialLoadFunc(index, _allProductsInCollections, allSubCategories) {
    if (!categories || !categories.length) return;

    if (hasMore && allSubCategories.length) {
      var _category = allSubCategories[index];
      var isSuper = slug[0] === 'smart';
      getProductsToShow(_category, _allProductsInCollections, false, isSuper);
    }
  }

  function scrollToActiveProduct() {
    setTimeout(function () {
      var elemToScrollTo = document.getElementById("pr".concat(products/* ActiveProduct.getValue */.nv.getValue()));

      if (elemToScrollTo) {
        elemToScrollTo.scrollIntoView({
          behavior: 'auto',
          block: 'center'
        });
        products/* ActiveProduct.update */.nv.update('');
        loader/* default.removeEvent */.Z.removeEvent('SMART_SCROLL');
      } else {
        loader/* default.removeEvent */.Z.removeEvent('SMART_SCROLL');
        products/* ActiveProduct.update */.nv.update('');
        products/* CalledSuperProductCategories.update */.r1.update(1);
      }
    }, 500);
  }

  (0,react.useEffect)(function () {
    if (!slug) return utils/* earlyInUseEffect */.Z;
    if (!categories || !categories.length) return utils/* earlyInUseEffect */.Z;
    if (!productCollections) return utils/* earlyInUseEffect */.Z;

    if (slug[0] === 'smart') {
      var service = store_deliveryMode/* default.getValue */.Z.getValue();
      var collectionType = store_deliveryMode/* default.getCollectionAsNumber */.Z.getCollectionAsNumber(service) || [];
      var mainCollectionType = collectionType.find(function (c) {
        return c === "900" || c === '751';
      });
      if (!mainCollectionType) return;

      var _allProductsInCollections = productsCollection/* default.getProductsForCollections */.Z.getProductsForCollections(collectionType);

      setAllProductsInCollections(_allProductsInCollections);
      setProductsShowing({});
      setInfiniteScrollIndex(1);

      var _slug = (0,slicedToArray/* default */.Z)(slug, 1),
          categorySlug = _slug[0];

      if (categorySlug === 'smart') {
        var allSubCategories = categories.flatMap(function (c) {
          return c.subCategories;
        });
        setHasMore(true);
        setCategoriesShowing(allSubCategories);
        var localIndex = 0;
        var hasProd = false;

        if (products/* CalledSuperProductCategories.getValue */.r1.getValue() === 1 || products/* ActiveProduct.getValue */.nv.getValue() === '') {
          while (localIndex < allSubCategories.length && !hasProd) {
            if (allSubCategories.length) {
              var _category = allSubCategories[localIndex];
              var isSuper = slug[0] === 'smart';
              hasProd = getProductsToShow(_category, _allProductsInCollections, false, isSuper);
              setInfiniteScrollIndex(localIndex + 1);
            }

            localIndex = localIndex + 1;
          }
        }

        if (products/* CalledSuperProductCategories.getValue */.r1.getValue() !== 1 && products/* ActiveProduct.getValue */.nv.getValue() !== '') {
          loader/* default.addEvent */.Z.addEvent('SMART_SCROLL');

          for (var i = 0; i < products/* CalledSuperProductCategories.getValue */.r1.getValue(); i++) {
            initialLoadFunc(i, _allProductsInCollections, allSubCategories);
          }

          setInfiniteScrollIndex(products/* CalledSuperProductCategories.getValue */.r1.getValue());
          scrollToActiveProduct();
        } else {
          products/* CalledSuperProductCategories.update */.r1.update(1);
        }
      }
    }
  }, [categories, productCollections]);
  var productShowingLength = Object.keys(productsShowing).length;
  (0,react.useEffect)(function () {
    // send analytics view_item_list for every new category added to the viewport
    if (productShowingLength > 0) {
      var lastCategory = Object.keys(productsShowing)[productShowingLength - 1];
      (0,analytics/* viewItemList */.hW)((0,analytics/* getProductsCartInfo */.ez)(productsShowing[lastCategory]), {
        item_list_id: category === null || category === void 0 ? void 0 : category._id,
        item_list_name: category === null || category === void 0 ? void 0 : category.name
      });
    }
  }, [productShowingLength]); // Code for bots

  if (isEmpty_default()(categoriesShowing)) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      className: (ProductMenu_module_default()).visibilityHidden,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (ProductMenu_module_default()).listHeader,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
          className: (ProductMenu_module_default()).listTitle,
          children: isEmpty_default()(subCategory) ? category === null || category === void 0 ? void 0 : category.name : subCategory === null || subCategory === void 0 ? void 0 : subCategory.name
        })
      }), Object.values(staticProducts).map(function (productsArray, index) {
        var _category$subCategori, _category$subCategori2;

        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [isEmpty_default()(subCategory) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (ProductMenu_module_default()).listHeader,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              className: (ProductMenu_module_default()).listTitle,
              children: category === null || category === void 0 ? void 0 : (_category$subCategori = category.subCategories) === null || _category$subCategori === void 0 ? void 0 : (_category$subCategori2 = _category$subCategori[index]) === null || _category$subCategori2 === void 0 ? void 0 : _category$subCategori2.name
            })
          }), productsArray.map(function (product, pIndex) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(ProductListItem/* default */.Z, {
              _product: product,
              itemListName: isEmpty_default()(subCategory) ? category === null || category === void 0 ? void 0 : category.name : subCategory === null || subCategory === void 0 ? void 0 : subCategory.name,
              itemListId: isEmpty_default()(subCategory) ? category === null || category === void 0 ? void 0 : category.name : subCategory === null || subCategory === void 0 ? void 0 : subCategory.name,
              positionInList: pIndex + 1
            }, product._id);
          })]
        }, Object.keys(staticProducts)[index]);
      })]
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: (ProductMenu_module_default()).listContainer,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()((ProductMenu_module_default()).infiniteList, (0,defineProperty/* default */.Z)({}, (ProductMenu_module_default()).notSticky, !isSticky)),
      children: categoriesShowing && categoriesShowing.length !== 0 && Object.values(productsShowing).length !== 0 && /*#__PURE__*/(0,jsx_runtime.jsx)((react_infinite_scroller_default()), {
        threshold: 440 // 440px is the height of a category with 1 row of products
        ,
        hasMore: hasMore // keep it like this until we purge the logic of multiple async calls to local db for products
        ,
        initialLoad: false,
        loader: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {}, "0"),
        loadMore: loadFunc,
        children: Object.values(productsShowing).map(function (products, i) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(ProductList/* default */.Z, {
            products: products,
            category: categoriesShowing[i],
            categoriesShowing: categoriesShowing,
            slug: slug,
            banners: banners,
            showBySelection: showBySelection,
            isSecondLevelPage: isSecondLevelPage,
            categories: categories,
            loading: loading,
            itemListId: category === null || category === void 0 ? void 0 : category._id,
            itemListName: category === null || category === void 0 ? void 0 : category.name
          }, categoriesShowing[i]._id);
        })
      })
    })
  });
}
// EXTERNAL MODULE: ./src/store/cart.js
var cart = __webpack_require__(88362);
// EXTERNAL MODULE: ./src/store/categories.js
var store_categories = __webpack_require__(9266);
// EXTERNAL MODULE: ./src/store/productsSort.js
var productsSort = __webpack_require__(43660);
// EXTERNAL MODULE: ./src/utils/bannerOptions.js
var bannerOptions = __webpack_require__(76962);
// EXTERNAL MODULE: ./src/pages/offers/offers.module.scss
var offers_module = __webpack_require__(6089);
var offers_module_default = /*#__PURE__*/__webpack_require__.n(offers_module);
;// CONCATENATED MODULE: ./src/pages/smart/index.jsx
























var __N_SSG = true;
function Super(_ref) {
  var navigation = _ref.navigation,
      footerLinks = _ref.footerLinks,
      meta = _ref.meta;

  var _useState = (0,react.useState)(bannerOptions/* default.catalog */.Z.catalog),
      showBySelection = _useState[0],
      setShowBySelection = _useState[1];

  var _useState2 = (0,react.useState)(0),
      numOfProducts = _useState2[0],
      setNumOfProducts = _useState2[1];

  var _useState3 = (0,react.useState)(''),
      deliveryMode = _useState3[0],
      setDeliveryMode = _useState3[1];

  var _useState4 = (0,react.useState)(),
      productCollections = _useState4[0],
      setProductCollections = _useState4[1];

  var _useState5 = (0,react.useState)(),
      categories = _useState5[0],
      setCategories = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      isCartVisible = _useState6[0],
      setIsCartVisible = _useState6[1];

  var slug = ['smart'];
  (0,react.useEffect)(function () {
    var subscriptionDeliveryMode = store_deliveryMode/* default.subscribe */.Z.subscribe(setDeliveryMode);
    var productsCollection$ = productsCollection/* default.subscribe */.Z.subscribe(setProductCollections);
    var isCartVisible$ = cart/* default.getIsVisble$ */.ZP.getIsVisble$().subscribe(setIsCartVisible);
    var sortBy$ = productsSort/* default.subscribe */.Z.subscribe(setShowBySelection);
    var categories$ = store_categories/* default.subscribe */.Z.subscribe(setCategories);
    return function () {
      sortBy$.unsubscribe();
      categories$.unsubscribe();
      isCartVisible$.unsubscribe();
      productsCollection$.unsubscribe();
      subscriptionDeliveryMode.unsubscribe();
    };
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CustomMetaHead/* default */.Z, {
      meta: meta
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (index_module_default()).headerContainer,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {
        navigation: navigation
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Navigation/* default */.Z, {
      navigation: navigation
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(DeliveryBanner/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(CategoriesSelect/* default */.Z, {
      slug: slug
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("main", {
      className: classnames_default()((offers_module_default()).main, (0,defineProperty/* default */.Z)({}, (offers_module_default()).spaceOpenCart, isCartVisible)),
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()([(offers_module_default()).mainLeft, (offers_module_default()).listBanner]),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: classnames_default()([(offers_module_default()).sticky]),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CategoriesBanner/* default */.Z, {
            onChangeOrderBy: function onChangeOrderBy(e) {
              return productsSort/* default.update */.Z.update(e.target.value);
            },
            showBySelection: showBySelection,
            numOfProducts: numOfProducts,
            categoryName: 'Έξυπνες αγορές',
            subCategoryName: null,
            slug: slug,
            deliveryMode: deliveryMode,
            isProductList: false
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
          className: (offers_module_default()).mainContent,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (offers_module_default()).hideOnSmallScreen,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: classnames_default()([(offers_module_default()).sticky, (offers_module_default()).categoriesAsideTop]),
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FavoritesAside/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(CategoriesAside/* default */.Z, {
                slug: slug
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (offers_module_default()).offerListWrapper,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(SmartProductMenu, {
              isSecondLevelPage: false,
              categories: categories,
              productCollections: productCollections,
              slug: slug,
              setNumOfProducts: setNumOfProducts,
              deliveryMode: deliveryMode,
              showBySelection: showBySelection
            })
          })]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {
      footerLinks: footerLinks
    })]
  });
}

/***/ }),

/***/ 90952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ earlyInUseEffect; }
/* harmony export */ });
/**
 * Use to early return in useEffect.
 * Usage example `return earlyInUseEffect;`
 */
function earlyInUseEffect() {
  return {};
}

/***/ }),

/***/ 17288:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/smart",
      function () {
        return __webpack_require__(58847);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2719:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"noProductsContainer":"NoProductsPlaceholder_noProductsContainer__iDJPl","icon":"NoProductsPlaceholder_icon__2InZU","noProducts":"NoProductsPlaceholder_noProducts__bihY_"};

/***/ }),

/***/ 54820:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"ProductMenu_listContainer__ks2Ns","infiniteList":"ProductMenu_infiniteList__8zE3B","notSticky":"ProductMenu_notSticky__Q5FIP","listTitle":"ProductMenu_listTitle__PxrUW","listHeader":"ProductMenu_listHeader__Crgmj","options":"ProductMenu_options__soiZ6","bannerContainer":"ProductMenu_bannerContainer__V5Oou","categoryContainer":"ProductMenu_categoryContainer__TQ0Xh","selectBrand":"ProductMenu_selectBrand__blXFc","centerNoProducts":"ProductMenu_centerNoProducts__LB64y","bannerLink":"ProductMenu_bannerLink__jJoSR","hideOnSmallScreen":"ProductMenu_hideOnSmallScreen__L_Gdk","visibilityHidden":"ProductMenu_visibilityHidden__6Pghu"};

/***/ }),

/***/ 66351:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"ThirdLevelCategories_container__N0hPJ","button":"ThirdLevelCategories_button__fmCPq","buttonSelected":"ThirdLevelCategories_buttonSelected__ydz5S"};

/***/ }),

/***/ 6089:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"offers_main__5BFjK","mainLeft":"offers_mainLeft__b_wmD","mainContent":"offers_mainContent__bu7so","defaultContainer":"offers_defaultContainer__vp9WM","listContainer":"offers_listContainer__GvH7s","listBannerOffers":"offers_listBannerOffers__zWyvx","listBannerSearch":"offers_listBannerSearch__3NIDZ","mainList":"offers_mainList__913K5","listSearch":"offers_listSearch__psc6T","sticky":"offers_sticky__VxnOS","categoriesAsideTop":"offers_categoriesAsideTop__mBEVk","categoriesAsideProductDetails":"offers_categoriesAsideProductDetails__uCWg3","spaceOpenCart":"offers_spaceOpenCart__CKYCF","productsListContainer":"offers_productsListContainer__GyCFF","offerListWrapper":"offers_offerListWrapper__GGHl2","offerListContainer":"offers_offerListContainer__Ptw4d","hideOnSmallScreen":"offers_hideOnSmallScreen__zb_V5"};

/***/ }),

/***/ 28833:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"index_headerContainer__J9svF"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5937,9866,1228,4617,5445,3609,260,2013,3253,3996,4843,6864,9950,7730,9878,3231,9774,2888,179], function() { return __webpack_exec__(16395), __webpack_exec__(17288); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);